export default __webpack_public_path__ + "static/media/WordsWithNoMeaning-Mastered5.8a8ff553.mp3";